import { createContext, useContext, useState, ReactNode } from 'react'
const PageTitleContext = createContext(null)

export const PageTitleProvider = ({
  initialPageTitle,
  children,
}: {
  initialPageTitle?: ReactNode
  children: ReactNode
}) => {
  const [pageTitle, setPageTitle] = useState(initialPageTitle)

  return (
    <PageTitleContext.Provider value={{ pageTitle, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  )
}

export const usePageTitle = () => useContext(PageTitleContext)
